import { useQuery } from '@tanstack/react-query';
import api from '@pasqal/core/api';
import { parseDevice, parseDeviceChannels } from '~/util/devicesParser';
import type * as schema from '~/models/pulser-schema';

/**
 * Get an object with the devices specs
 */
export const useDevicesSpecs = () => {
  return useQuery({
    queryKey: ['devicesSpecs'],
    queryFn: async () => {
      const response = await api.devices.fetchAllDeviceSpecs();
      const rawSpecs = response?.data;

      if (!rawSpecs) {
        throw new Error('No devices specs available.');
      }

      const devicesSpecs = Object.fromEntries(
        Object.entries(rawSpecs).map(([key, specString]) => [
          key.toLowerCase(),
          JSON.parse(specString)
        ])
      );

      const parsedSpecs = Object.fromEntries(
        Object.entries(devicesSpecs).map(
          ([key, spec]: [string, schema.Device]) => [
            key,
            {
              device: parseDevice(spec),
              channels: parseDeviceChannels(spec)
            }
          ]
        )
      );

      return {
        devicesSpecs: parsedSpecs,
        deviceNames: Object.values(parsedSpecs).map((spec) => spec.device.name)
      };
    }
  });
};
